import { useEffect, useState } from 'preact/hooks';

export type Route =
  | 'overview'
  | 'feedback'
  | 'roadmap'
  | 'changelog'
  | 'players'
  | 'rooms'
  | 'telemetry'
  | 'progression'
  | 'choir'
  | 'flags'
  | 'login';

const ROUTES: Route[] = [
  'overview',
  'feedback',
  'roadmap',
  'changelog',
  'players',
  'rooms',
  'telemetry',
  'progression',
  'choir',
  'flags',
  'login',
];

function parseHash(): Route {
  const raw = window.location.hash.replace(/^#\/?/, '').split('?')[0]?.split('/')[0] ?? '';
  return (ROUTES as string[]).includes(raw) ? (raw as Route) : 'overview';
}

export function navigate(route: Route): void {
  window.location.hash = `#/${route}`;
}

export function useRoute(): Route {
  const [route, setRoute] = useState<Route>(parseHash());
  useEffect(() => {
    const onHashChange = () => setRoute(parseHash());
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);
  return route;
}
